import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_102: FaireProductEntity = {
  token: "catalog_prod_prod-102",
  type: "product",
  name: "Decorative Item A - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 90.81,
  msrpDollars: 227.03,
  sku: "CA0102",
  caseSize: 4,
  material: "Cotton",
  collectionToken: "col_camp",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 82,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
